<template>
  <div id="map-container">
    <div ref="result"/>
    <google-map
      id="map"
      ref="Map"
      class="h-full"
      :center="coordinate"
      :zoom="zoom"
      :options="defaultMapOptions"
    >
      <div>
        <google-map-marker
          :position.sync="marker.location"
          :show.sync="showInfo"
          @click="toggleInfoWindow(marker)"
          v-for="(marker, index) in map_markers"
          :clickable="true"
          :options="{optimized: false}"
          v-if="!refreshMarkers && (coordinate_local && !deliverToMe && areaPointsNear(marker) || !coordinate_local || (coordinate_local && deliverToMe))"
          :key="index"
          :icon="{url: require('@/assets/images/logo/pin.png'), scaledSize: {width: 64, height: 64}}"
        />
        <google-map-marker
          v-if="coordinate"
          :position.sync="coordinate_local"
          :clickable="true"
          :options="{optimized: false}"
          :show.sync="showInfo"
          :icon="{url: require('@/assets/images/logo/pin-red.png'), scaledSize: {width: 1, height: 1}}"
        />
        <google-map-infowindow
          v-if="selectedMarker"
          :show.sync="showInfo"
          :position.sync="selectedMarker.location"
          :options="{ pixelOffset: { width: 0, height: -75 } }"
          @info-window-clicked="infoClicked"
        >
          <div v-html="defaultMapOptions.description"></div>
        </google-map-infowindow>
        <google-map-circle
          v-if="coordinate_local && !deliverToMe"
          :center="coordinate_local"
          ref="circle"
          :radius="radius_local"
          :fillColor="'red'"
          :fillOpacity="0"
        />
      </div>
  </google-map>
  </div>
</template>

<script>

export default {
  props: {
    coordinate: {
      type: Object
    },
    radius: {
      type: String
    },
    deliverToMe: {
      type: Boolean,
      default: false
    }
  },
  name: 'RestaurantsOnMapComponent',
  data () {
    return {
      defaultMapOptions: {
        title: 'Delivery Location',
        description: '',
        gestureHandling: 'greedy',
        mapTypeControl: false,
        draggable:true,
        styles: [
          {
            featureType: 'poi',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'administrative.province',
            elementType: 'geometry',
            stylers: [
              {
                color: '#ff0000'
              }
            ]
          },
          {
            featureType: 'administrative.province',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#ff0000'
              }
            ]
          }
        ]
      },
      zoom: 13,
      showInfo: false,
      location:null,
      geocoder: null,
      placeService: null,
      selectedMarker: null,
      refreshMarkers: false,
      infoloc: {
        lat: 0,
        lng: 0
      },
      markers: [],
      coordinate_local: this.coordinate,
      radius_local: 1000
    }
  },
  watch: {
    refreshMarkers () {
      if (this.refreshMarkers) {
        setTimeout(() => {
          this.refreshMarkers = false
        }, 500)
      }
    },
    coordinate () {
      this.refreshMarkers = true
      if (this.coordinate) {
        this.coordinate_local = this.coordinate
        this.radius_local = Number.parseInt(this.radius) * 1000
        this.fitCircle()
        if (this.deliverToMe) {
          this.getHomeRestaurantList()
        }
      } else {
        this.coordinate_local = this.coordinate
        this.getRestaurantList()
      }
    },
    radius () {
      this.radius_local = Number.parseInt(this.radius) * 1000
      this.fitCircle()
    },
    deliverToMe () {
      // this.map.reload()
      if (this.deliverToMe && this.coordinate) {
        this.getHomeRestaurantList()
      }
    }
  },
  computed: {
    map () {
      return this.$refs.Map
    },
    map_markers () {
      const marker_map = []
      this.markers.map(marker => {
        const markerData = {
          data: marker,
          location: JSON.parse(marker.user_property.Location)
        }
        marker_map.push(markerData)
      })
      return marker_map
    }
  },
  methods: {
    rad (x) {
      return x * Math.PI / 180
    },
    areaPointsNear (marker) {
      const p1 = this.coordinate
      const p2 = marker.location
      const R = 6378137 // Earth’s mean radius in meter
      const dLat = this.rad(p2.lat - p1.lat)
      const dLong = this.rad(p2.lng - p1.lng)
      const a = (Math.sin(dLat / 2) * Math.sin(dLat / 2)) +
        (Math.cos(this.rad(p1.lat)) * Math.cos(this.rad(p2.lat)) *
        Math.sin(dLong / 2) * Math.sin(dLong / 2))
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      const result = R * c
      return result < this.radius_local
    },
    fitBounds () {
      const bounds = new window.google.maps.LatLngBounds()
      this.map_markers.map(marker => {
        bounds.extend(marker.location)
      })
      this.$refs.Map.fitBounds(bounds)
    },
    fitCircle () {
      if (this.coordinate_local) {
        setTimeout(() => {
          const bounds = new window.google.maps.LatLngBounds()
          if (this.$refs.circle) {
            bounds.union(this.$refs.circle.getBounds())
            this.$refs.Map.fitBounds(bounds)
          }
        }, 200)
      }
    },
    async getLocation () {

      return new Promise((resolve, reject) => {
        if (!('geolocation' in navigator)) {
          reject(new Error('Geolocation is not available.'))
        }

        navigator.geolocation.getCurrentPosition(pos => {
          resolve(pos)
        }, err => {
          reject(err)
        })

      })
    },
    async locateMe () {

      this.gettingLocation = true
      try {
        this.gettingLocation = false
        const location = await this.getLocation()
        this.coordinate_local = {
          lat: location.coords.latitude,
          lng: location.coords.longitude
        }
      } catch (e) {
        this.gettingLocation = false
        this.errorStr = e.message
      }

    },
    toggleInfoWindow (marker) {
      this.selectedMarker = marker
      this.showInfo = true
      this.defaultMapOptions.description =
        `<h5>${marker.data.user_property['Restaurant-Name']}</h5>
        <p>${marker.data.user_property['Address']}</p>
        <a href="/restaurants/${marker.data.user_property['Alias']}"><div class="claim-button">Order</div></a>`
    },
    infoClicked () {
    },
    getPlaceDetails (place_id, callback) {
      const self = this
      this.placeService.getDetails({placeId: place_id}, function (PlaceResult) {
        // PlaceResult is an object
        // PlacesServiceStatus is a string
        self.selectedPlace = PlaceResult
        callback(PlaceResult)
      })
    },
    getAddressLocation (address_text, callback) {
      const addressObj = {
        address: address_text,
        country: 'United States'
      }
      this.geocoder.geocode(addressObj, (response, status) => {
        if (status === window.google.maps.GeocoderStatus.OK) {
          callback(response[0].place_id)
        }
      })
    },
    handleAddress () {

      const place_str = ''

      this.getAddressLocation(place_str, (response) => {
        this.getPlaceDetails(response, (response) => {
          if (response.photos) {
            const url = response.photos[Math.floor(Math.random() * response.photos.length)].getUrl()
            this.$store.dispatch('api/setSelectedImage', url)
          }
        })
      })
    },
    getRestaurantList () {
      this.$vs.loading()
      this.$store.dispatch('api/getRestaurantListAllRestaurants')
        .then((response) => {
          this.$vs.loading.close()
          this.markers = response.data.data
          //this.fitBounds()
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })

    },
    getHomeRestaurantList () {
      this.$vs.loading()
      const payload = {
        lat: this.coordinate.lat,
        lng: this.coordinate.lng
      }
      this.$store.dispatch('api/getHomeRestaurantList', payload)
        .then((response) => {
          this.$vs.loading.close()
          this.markers = response.data.data
          this.fitBounds()
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })

    }
  },
  mounted () {
    this.geocoder = new window.google.maps.Geocoder(this.$refs.result)
    this.placeService = new window.google.maps.places.PlacesService(this.$refs.result)
    //this.locateMe()
    this.getRestaurantList()
  }
}
</script>

<style scoped>

</style>
